var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7135 3.99636C12.4411 3.72383 12.1177 3.50764 11.7617 3.36014C11.4057 3.21264 11.0242 3.13672 10.6388 3.13672C10.2535 3.13672 9.87195 3.21264 9.51597 3.36014C9.15999 3.50764 8.83656 3.72383 8.56416 3.99636L7.99883 4.56169L7.43349 3.99636C6.88326 3.44612 6.13698 3.137 5.35883 3.137C4.58067 3.137 3.8344 3.44612 3.28416 3.99636C2.73392 4.5466 2.4248 5.29287 2.4248 6.07103C2.4248 6.84918 2.73392 7.59546 3.28416 8.14569L3.84949 8.71103L7.99883 12.8604L12.1482 8.71103L12.7135 8.14569C12.986 7.87329 13.2022 7.54986 13.3497 7.19388C13.4972 6.8379 13.5731 6.45635 13.5731 6.07103C13.5731 5.6857 13.4972 5.30415 13.3497 4.94817C13.2022 4.59219 12.986 4.26876 12.7135 3.99636V3.99636Z",
    stroke: "#434243",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c44108a907934454c09cdcbad484ef10.svg";
export { ForwardRef as ReactComponent };